import styled from "styled-components";

export const MyFormCollaboratorRegister = styled.form`
  width: 100%;
  max-width: 700px;
  margin: 0 auto;
  display: grid;
  gap: 32px 16px;
  grid-template-columns: 1fr;
  grid-template-areas: "checkSlide" "nome" "cpf" "email" "tipo" "telefone" "perfil" "loja" "delivery" "buttom";

  > :nth-child(1) {
    grid-area: checkSlide;
    margin: 0 auto;
  }

  > :nth-child(2) {
    grid-area: nome;
  }

  > :nth-child(3) {
    grid-area: cpf;
  }

  > :nth-child(4) {
    grid-area: email;
  }
  > :nth-child(5) {
    grid-area: tipo;
  }
  > :nth-child(6) {
    grid-area: telefone;
  }
  > :nth-child(7) {
    grid-area: perfil;
  }
  > :nth-child(8) {
    grid-area: loja;
  }
  > :nth-child(9) {
    grid-area: delivery;
  }
  > :nth-child(10) {
    grid-area: buttom;
    > button {
      margin: 0 auto;
    }
  }

  @media (min-width: 640px) {
    grid-template-columns: 1fr 1fr;
    grid-template-areas: "checkSlide checkSlide" "nome nome" "cpf telefone" "email tipo" "perfil perfil" "loja delivery" "buttom buttom";
  }
`;
